// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actionButtons_DDCnG {
    display: flex;
    gap: 12px;
}

.actionBtn_RNfV7 {
    flex: 1 1;
    padding: 3px 4px;
    border: 1px solid var(--e2e8f0-border);
    background: var(--white-background);
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 8px;
    transition: all 0.2s ease;
    color: var(--64748b-color);

}

.actionBtn_RNfV7:hover {
    background: var(--fafbfc-background);
    border-color: var(--cbd5e1-border);
    transform: translateY(-1px);
}

.actionBtn_RNfV7.primary_y9Crk {
    background: linear-gradient(135deg, var(--10b981-background) 0%, var(--059669-background) 100%);
    color: var(--white-background);
    border-color: var(--10b981-background);
    box-shadow: 0 2px 4px var(--black-12902-shadow);
}

.actionBtn_RNfV7.primary_y9Crk:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px var(--green-12003-shadow);
}

@media (max-width: 768px) {
    .actionButtons_DDCnG {
        flex-direction: column;
    }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/DashboardComponents/Main/ActionButtons/ActionButtons.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,sCAAsC;IACtC,mCAAmC;IACnC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,QAAQ;IACR,yBAAyB;IACzB,0BAA0B;;AAE9B;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,+FAA+F;IAC/F,8BAA8B;IAC9B,sCAAsC;IACtC,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".actionButtons {\n    display: flex;\n    gap: 12px;\n}\n\n.actionBtn {\n    flex: 1 1;\n    padding: 3px 4px;\n    border: 1px solid var(--e2e8f0-border);\n    background: var(--white-background);\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    gap: 8px;\n    transition: all 0.2s ease;\n    color: var(--64748b-color);\n\n}\n\n.actionBtn:hover {\n    background: var(--fafbfc-background);\n    border-color: var(--cbd5e1-border);\n    transform: translateY(-1px);\n}\n\n.actionBtn.primary {\n    background: linear-gradient(135deg, var(--10b981-background) 0%, var(--059669-background) 100%);\n    color: var(--white-background);\n    border-color: var(--10b981-background);\n    box-shadow: 0 2px 4px var(--black-12902-shadow);\n}\n\n.actionBtn.primary:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px var(--green-12003-shadow);\n}\n\n@media (max-width: 768px) {\n    .actionButtons {\n        flex-direction: column;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionButtons": `actionButtons_DDCnG`,
	"actionBtn": `actionBtn_RNfV7`,
	"primary": `primary_y9Crk`
};
export default ___CSS_LOADER_EXPORT___;
